import { RatesRequest } from '@mortgage-pos/types'

/**
 * Sanitizes an integer field value for GraphQL submission
 */
export const sanitizeIntFieldForGraphQL = (value: any): number | null => {
  // Empty strings and null/undefined are converted to null (GraphQL won't accept "" for Int type)
  if (value === '' || value == null) {
    return null
  }

  // Numeric strings (including "0") are parsed to integers
  return parseInt(value)
}

/**
 * Sanitizes a float field value for GraphQL submission
 */
export const sanitizeFloatFieldForGraphQL = (value: unknown): number | null => {
  // Empty strings and null/undefined are converted to null (GraphQL won't accept "" for Float type)
  if (value === '' || value == null) {
    return null
  }

  const parsed = typeof value === 'number' ? value : parseFloat(String(value))
  return Number.isNaN(parsed) ? null : parsed
}

export const trimWhiteSpaces = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'string' || obj[key] instanceof String)
      obj[key] = obj[key].trim()
  })
  return obj
}

export const removeTrailingPunctuations = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'string' || obj[key] instanceof String)
      if (obj[key].slice(-1) === '.') obj[key] = obj[key].slice(0, -1)
  })
  return obj
}

/**
 * Validates that a zip code is in valid US format (5 digits or 5+4 with dash)
 */
export const validateZipCode = (zipCode: string): boolean => {
  if (!zipCode) return false
  // 5 digits or 5 digits + dash + 4 digits
  const zipRegex = /^\d{5}(-\d{4})?$/
  return zipRegex.test(zipCode)
}

export const ratesInputSanitization = (request: RatesRequest) => {
  request = trimWhiteSpaces(request)
  request = removeTrailingPunctuations(request)

  // Validate zip code format (zipCode is required by GraphQL schema)
  if (!validateZipCode(request.zipCode)) {
    throw new Error(
      `Invalid zip code format: ${request.zipCode}. Must be 5 digits or 5+4 format (e.g., 12345 or 12345-6789)`
    )
  }

  return request
}
